/* Reboot Society — client-side behaviors layered on top of Dawn.
 * Keep this file small. Anything Shopify (cart, checkout, predictive search)
 * is handled by Dawn's existing JS. We only add chrome interactions.
 */
(function () {
  'use strict';

  /* ---------- Announcement bar rotator ----------
   * Sections with [data-rs-announce] hold one or more [data-rs-announce-msg].
   * Cycle visibility every N ms (default 4500). Pauses when tab hidden.
   */
  function initAnnounceBars() {
    document.querySelectorAll('[data-rs-announce]').forEach(function (root) {
      var msgs = root.querySelectorAll('[data-rs-announce-msg]');
      if (msgs.length < 2) return;
      var interval = parseInt(root.getAttribute('data-rs-interval'), 10) || 4500;
      var i = 0;
      msgs.forEach(function (m, idx) { m.hidden = idx !== 0; });
      var timer = setInterval(function () {
        if (document.hidden) return;
        msgs[i].hidden = true;
        i = (i + 1) % msgs.length;
        msgs[i].hidden = false;
      }, interval);
      root.addEventListener('beforeunload', function () { clearInterval(timer); });
    });
  }

  /* ---------- Marquee duplication ----------
   * For seamless infinite scroll, the track needs its content twice.
   * Author writes content once, JS clones it.
   */
  function initMarquees() {
    document.querySelectorAll('[data-rs-marquee]').forEach(function (root) {
      var track = root.querySelector('[data-rs-marquee-track]');
      if (!track || track.dataset.rsMarqueeCloned === '1') return;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.parentNode.appendChild(clone);
      track.dataset.rsMarqueeCloned = '1';
    });
  }

  /* ---------- Accordion toggles ----------
   * Buttons with [data-rs-accordion-toggle] toggle the next [data-rs-accordion-body].
   * Used in PDP description, FAQ, etc.
   */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rs-accordion-toggle]');
      if (!btn) return;
      var group = btn.closest('[data-rs-accordion-group]');
      var item = btn.closest('[data-rs-accordion-item]');
      if (!item) return;
      var willOpen = !item.hasAttribute('data-rs-open');
      // Single-open mode: close siblings if group has data-rs-accordion-single
      if (group && group.hasAttribute('data-rs-accordion-single')) {
        group.querySelectorAll('[data-rs-accordion-item][data-rs-open]').forEach(function (sib) {
          if (sib !== item) sib.removeAttribute('data-rs-open');
        });
      }
      if (willOpen) item.setAttribute('data-rs-open', '');
      else item.removeAttribute('data-rs-open');
      btn.setAttribute('aria-expanded', String(willOpen));
    });
  }

  /* ---------- Cart drawer open hook ----------
   * Dawn already manages the cart-drawer.js component. We just expose a helper
   * that our header's cart button can call: window.rsOpenCart().
   */
  window.rsOpenCart = function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(document.activeElement);
    } else {
      // Fallback: navigate to /cart if drawer isn't enabled
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  };

  /* ---------- Cart count subscription ----------
   * Dawn publishes 'cart-update' events through pubsub.js. Mirror the count
   * into [data-rs-cart-count] so our header reflects updates without a reload.
   */
  function initCartCount() {
    if (!window.subscribe || !window.PUB_SUB_EVENTS) return;
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (!e || !e.cartData) return;
      document.querySelectorAll('[data-rs-cart-count]').forEach(function (el) {
        el.textContent = e.cartData.item_count != null ? e.cartData.item_count : el.textContent;
      });
    });
  }

  /* ---------- PDP variant picker ----------
   * Buttons with .rs-variant-pill grouped under [data-rs-option-name].
   * On click: toggle .active in the group, look up matching variant from
   * the JSON in [data-rs-variant-data], update [data-rs-variant-id] hidden
   * input, and update price + add button label.
   * If selected combination is unavailable, disable add button + label "Sold out".
   */
  function initVariantPickers() {
    document.querySelectorAll('.rs-product-form-wrapper').forEach(function (root) {
      // Variant data sits as a sibling of the form, scoped to the .rs-pdp-info panel
      var infoPanel = root.closest('.rs-pdp-info') || root.parentElement;
      var dataEl = infoPanel && infoPanel.querySelector('[data-rs-variant-data]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = root.querySelector('[data-rs-variant-id]');
      var addBtn = root.querySelector('[data-rs-add-button]');
      var addLabel = root.querySelector('[data-rs-add-label]');
      var priceCurrent = infoPanel.querySelector('[data-rs-price-current]');
      var priceCompare = infoPanel.querySelector('[data-rs-price-compare]');

      var groups = Array.from(root.querySelectorAll('[data-rs-option-name]'));
      groups.sort(function (a, b) {
        return parseInt(a.dataset.rsOptionPosition, 10) - parseInt(b.dataset.rsOptionPosition, 10);
      });

      function formatMoney(cents) {
        var d = cents / 100;
        return d % 1 === 0 ? '$' + d : '$' + d.toFixed(2);
      }

      function update() {
        if (groups.length === 0) return; // single-variant product, nothing to pick
        var selected = groups.map(function (g) {
          var active = g.querySelector('.rs-variant-pill.active');
          return active ? active.dataset.rsVariantValue : null;
        });
        if (selected.indexOf(null) >= 0) return;

        var matched = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });

        if (!matched) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
          return;
        }

        if (idInput) idInput.value = matched.id;
        if (addBtn) addBtn.disabled = !matched.available;
        if (priceCurrent) priceCurrent.textContent = formatMoney(matched.price);
        if (priceCompare) {
          if (matched.compare_at_price && matched.compare_at_price > matched.price) {
            priceCompare.textContent = formatMoney(matched.compare_at_price);
            priceCompare.style.display = '';
          } else {
            priceCompare.style.display = 'none';
          }
        }
        if (addLabel) {
          addLabel.textContent = matched.available
            ? 'Add to cart — ' + formatMoney(matched.price)
            : 'Sold out';
        }
        // Update URL with ?variant= so refresh keeps the selection (Dawn convention)
        if (history.replaceState && matched.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          history.replaceState({}, '', url.toString());
        }
      }

      root.querySelectorAll('.rs-variant-pill').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.classList.contains('active')) return;
          var group = btn.closest('[data-rs-option-name]');
          if (!group) return;
          group.querySelectorAll('.rs-variant-pill').forEach(function (b) {
            b.classList.remove('active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
          update();
        });
      });
    });
  }

  /* ---------- Mobile nav toggle ----------
   * Hamburger button [data-rs-menu-toggle] toggles the .rs-mobile-nav
   * dropdown below the header. Closes on outside-click and on link-click.
   */
  function initMobileMenu() {
    var btn = document.querySelector('[data-rs-menu-toggle]');
    var nav = document.getElementById('rs-mobile-nav');
    if (!btn || !nav) return;

    function setOpen(open) {
      nav.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('rs-mobile-nav-open', open);
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(nav.hidden);
    });

    // Close when a link inside is clicked (navigating away anyway, but ensures clean state)
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (nav.hidden) return;
      if (e.target.closest('#rs-mobile-nav') || e.target.closest('[data-rs-menu-toggle]')) return;
      setOpen(false);
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !nav.hidden) setOpen(false);
    });
  }

  /* ---------- PDP gallery (thumbnail swap with preload) ----------
   * Clicking a [data-rs-gallery-thumb] swaps the main image's src to the
   * thumb's data-rs-media-src.
   *
   * Performance: thumbs render at 400w (small JPEG); the high-res they
   * swap to is 1600w (~200-500KB). Without preloading the high-res, every
   * tap = fresh network request + decode + paint, which feels like a 3-4s
   * dead zone on mobile. Fix: kick off a background fetch of every thumb's
   * high-res variant after page-load idle so they're in the browser HTTP
   * cache by the time the user taps. Pair with a visible loading state
   * (.is-loading on the main wrap) so even if a swap still has to wait,
   * the user gets immediate feedback that their tap registered.
   */
  function initProductGallery() {
    document.querySelectorAll('[data-rs-pdp-gallery]').forEach(function (gallery) {
      var mainWrap = gallery.querySelector('[data-rs-gallery-main]');
      if (!mainWrap) return;
      var mainImg = mainWrap.querySelector('img');
      if (!mainImg) return;
      var thumbs = gallery.querySelectorAll('[data-rs-gallery-thumb]');

      // Track which high-res URLs we've started preloading so we don't
      // double-fetch.
      var preloaded = Object.create(null);
      function preload(src) {
        if (!src || preloaded[src]) return;
        preloaded[src] = true;
        var img = new Image();
        img.src = src;
        // The browser caches the response; we don't need a load handler.
      }

      // Background preload pass — defer to idle so it doesn't fight with
      // the initial render. Falls back to setTimeout for Safari < 16.4.
      function preloadAll() {
        thumbs.forEach(function (t) { preload(t.dataset.rsMediaSrc); });
      }
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(preloadAll, { timeout: 2500 });
      } else {
        setTimeout(preloadAll, 1500);
      }

      thumbs.forEach(function (thumb) {
        // Also preload on hover (desktop) / touchstart (mobile) — earliest
        // possible signal that the user is about to tap this thumb. Cheap
        // and racey to the click handler.
        var pointerPreload = function () { preload(thumb.dataset.rsMediaSrc); };
        thumb.addEventListener('mouseenter', pointerPreload, { passive: true });
        thumb.addEventListener('touchstart', pointerPreload, { passive: true });

        thumb.addEventListener('click', function (e) {
          e.preventDefault();
          var src = thumb.dataset.rsMediaSrc;
          var alt = thumb.dataset.rsMediaAlt || mainImg.alt;
          if (!src) return;
          if (thumb.classList.contains('active')) return;

          // Show loading state immediately so user knows the tap registered
          mainWrap.classList.add('is-loading');

          // Toggle .active state — instant UI feedback regardless of network
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');

          // Scroll the active thumb into view within the horizontal strip
          if (thumb.scrollIntoView) {
            thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }

          // Swap main image. If preloaded, this is instant (HTTP cache hit).
          // Otherwise the load event fires when network completes.
          var onLoaded = function () {
            mainWrap.classList.remove('is-loading');
            mainImg.removeEventListener('load', onLoaded);
            mainImg.removeEventListener('error', onLoaded);
          };
          mainImg.addEventListener('load', onLoaded, { once: true });
          mainImg.addEventListener('error', onLoaded, { once: true });

          mainImg.removeAttribute('srcset'); // force browser to use new src
          mainImg.src = src;
          mainImg.alt = alt;

          // Safety: if the image is already complete (HTTP cache hit), the
          // load event may not re-fire. Clear the loading state on next frame.
          requestAnimationFrame(function () {
            if (mainImg.complete && mainImg.naturalWidth > 0) onLoaded();
          });
        });
      });

      // "+N more" expand button: reveal the hidden thumbs and remove the
      // button itself.
      var thumbStrip = gallery.querySelector('[data-rs-pdp-thumbs]');
      var expandBtn = gallery.querySelector('[data-rs-thumb-expand]');
      if (thumbStrip && expandBtn) {
        expandBtn.addEventListener('click', function (e) {
          e.preventDefault();
          thumbStrip.classList.add('rs-expanded');
          var firstHidden = thumbStrip.querySelector('.rs-pdp-thumb-hidden');
          expandBtn.remove();
          if (firstHidden && firstHidden.scrollIntoView) {
            firstHidden.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      }
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initAnnounceBars();
    initMarquees();
    initAccordions();
    initCartCount();
    initVariantPickers();
    initMobileMenu();
    initProductGallery();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
